import Link from 'next/link';
import styled from '@emotion/styled';
import StyledLink from '@base/Link/Link';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import H1 from '@base/H1/H1';
import H3 from '@base/H3/H3';
import Paper from '@base/Paper/Paper';
import Image from '@base/Image';
import Button from '@base/Button/Button';
import useWindowSize from '@hooks/useWindowSize';
import P1 from '@base/P1/P1';
import {
  NEW_UNACADEMY_GIF,
  PUBLIC_NOTICE_URL,
  DARWINBOX_URL
} from './constants';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${Spacings.SPACING_0B};
  padding-left: 115px;
  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_12B};
    align-items: center;
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B};
    align-items: center;
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacings.SPACING_32B};
  width: 498px;
  align-items: flex-start;
  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_20B};
  }
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_18B};
    align-items: center;
    width: 328px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Headline = styled(H1)`
  width: 498px;
  line-height: 140%;
  ${mediaQuery.uptoTablet} {
    line-height: 120%;
    width: 350px;
    font-size: 38px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: 28px;
    text-align: center;
    width: 328px;
  }
`;
const SubText = styled(H3)`
  position: static;
  width: 497px;
  line-height: 150%;
  margin-top: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.REGULAR};
  ${mediaQuery.uptoTablet} {
    width: 350px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    text-align: center;
    width: 290px;
  }
`;
const ImageDiv = styled.div`
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_12B};
  }
`;
const StyledAnchor = styled.a`
  width: 264px;
  height: 60px;
  margin-top: ${Spacings.SPACING_12B};
  ${mediaQuery.uptoTablet} {
    width: 225px;
    height: 48px;
  }
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_12B};
    margin-bottom: ${Spacings.SPACING_22B};
  }
`;
const StyledButton = styled(Button)`
  width: 264px;
  height: 60px;

  ${mediaQuery.uptoTablet} {
    width: 225px;
    height: 48px;
  }
`;

const Tag = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-i-blue-27);
  padding: ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_1B};
  margin-bottom: ${Spacings.SPACING_8B};
  cursor: pointer;
`;

const StyledP1 = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  margin-left: ${Spacings.SPACING_2B};
`;

const JobOpeningButton = () => {
  return (
    <Link href={DARWINBOX_URL} passHref>
      <StyledAnchor>
        <StyledButton label="View all job openings" />
      </StyledAnchor>
    </Link>
  );
};
const Banner = () => {
  const { isMobile } = useWindowSize();
  return (
    <Wrapper>
      <TextWrapper>
        <StyledLink href={PUBLIC_NOTICE_URL} as={PUBLIC_NOTICE_URL}>
          <Tag>
            <Image
              src="speaker.svg"
              alt="announcement"
              width="24px"
              height="24px"
            />
            <StyledP1>Public notice from the team</StyledP1>
            <Image
              src="arrow-right.svg"
              alt="announcement"
              width="24px"
              height="24px"
            />
          </Tag>
        </StyledLink>
        <TitleWrapper>
          <Headline>Let’s build the future of education together</Headline>
          <SubText>
            Come, join us and together we can transform the way India learns.
          </SubText>
        </TitleWrapper>
        {!isMobile && <JobOpeningButton />}
      </TextWrapper>
      <ImageDiv>
        <Image
          src={NEW_UNACADEMY_GIF}
          alt="newUnacademy"
          width={isMobile ? 320 : 712}
          height={isMobile ? 234 : 520}
          priority
        />
      </ImageDiv>
      {isMobile && <JobOpeningButton />}
    </Wrapper>
  );
};
export default Banner;
